import './axios'
import router from '@/router'
import store from '@/store'
import { registerPrimeVue } from './primevue/primevue'
import { i18n } from './i18n'

export const registerPlugins = (app) => {
    app.use(store)
        .use(router)
        .provide('router', router)
        
    registerPrimeVue(app)
    app.use(i18n)
}